import React, { useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom"; // Import Navigate
import Dashboard from "./pages/Dashboard";
import Table from "./pages/Table";
import AuthLayout from "./components/Layout/AuthLayout";
import GuestLayout from "./components/Layout/GuestLayout";
import Login from "./pages/auth/Login";
import Groups from "./pages/Group/Groups";
import GroupForm from "./pages/Group/GroupForm";
import Form from "./pages/Form";
import Details from "./pages/Group/Details";
import RegisterIndex from "./pages/auth/Register";
import withSplashScreen from "./components/splashScreen";
import { useSelector } from "react-redux";
import axios from "axios";
const App = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  let isAuthenticated = user?.idToken ? true : false;
  const loginTime = localStorage.getItem('loginTime');
  if (!loginTime) {
    isAuthenticated = false
  } else {
    const thirtyMinutesInMillis = 30* 60* 1000;
    const currentTime = new Date().getTime();
    const elapsedTime = currentTime - parseInt(loginTime);
    setTimeout(() => {
      window.location.reload();
    }, thirtyMinutesInMillis);
    if (elapsedTime >= thirtyMinutesInMillis) {
      const requestData = {
        RefreshToken: user.refreshToken,
      };
      axios
        .post("https://splithub-dev.salmonocean-218390b4.centralindia.azurecontainerapps.io/oauth/google/refresh",
          requestData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          // Handle the successful response here
          // console.log("Received Access Token:", response);
          const newUser = response.data;
          user.idToken = newUser.idToken;
          isAuthenticated = user?.idToken ? true : false;
          const loginTime = new Date();
          localStorage.setItem('loginTime', loginTime.getTime());
          localStorage.setItem("user", JSON.stringify(user));
        })
        .catch((error) => {
          // Handle errors here
          localStorage.removeItem('user')
          localStorage.removeItem('loginTime')
          isAuthenticated = false;

          console.error(
            "Failed to exchange authorization code for access token:",
            error
          );
        })
        .finally(() => {
          // window.location.reload();
        })
    }


  }

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/auth/login", { replace: true }); // Redirect to homepage if authenticated
    }
  }, [isAuthenticated, navigate]); // Ensure useEffect runs whenever isAuthenticated or navigate changes

  return (
    <Routes>
      <Route path="/" element={<AuthLayout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/friends" element={<Table />} />
        <Route path="/groups" element={<Groups />} />
        <Route path="/group/:id" element={<Details />} />
        <Route path="/groupform" element={<GroupForm />} />
        <Route path="/form" element={<Form />} />
        <Route path="*" element={<Navigate to="/" replace />} />{" "}
        {/* Redirect to home for any undefined route */}
      </Route>
      <Route path="/auth" element={<GuestLayout />}>
        {isAuthenticated && (
          <Route path="*" element={<Navigate to="/" replace />} />
        )}{" "}
        {/* Redirect to homepage if authenticated user tries to visit any auth route */}
        <Route
          path="/auth/login"
          element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
        />
        <Route
          path="/auth/register"
          element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
        />
      </Route>
    </Routes>
  );
};

export default withSplashScreen(App);
